import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormGroup, FormArray, UntypedFormControl, Validators } from '@angular/forms';
import * as moment from 'moment';

import { BrandService } from 'shared/brand/brand.service';
import { maxLengthSpec } from 'shared/validation/lengthSpec-validation';


@Component({
  moduleId: module.id,
  selector: 'configure-export-name',
  templateUrl: 'configure-export-name.component.html',
  styleUrls: ['configure-export-name.component.scss'],
})
export class ConfigureExportNameComponent implements OnInit {

  nameControl: UntypedFormControl;
  maxCharactersCount: number = 100;
  datetime: string = '';

  get remainingCount(): number {
    if (!this.nameControl.value) { return this.maxCharactersCount; }
    return this.maxCharactersCount - this.nameControl.value.length;
  }

  get filename(): string {
    return `${this.brandId}_PIES_6.5${this.nameControl.value.length ? '_' : ''}${this.nameControl.value}_${this.datetime}`;
  }

  get isNameInvalid(): boolean {
    return this.nameControl.invalid;
  }

  get isNameDirty(): boolean {
    return this.nameControl.dirty;
  }

  get brandId(): any {
    return this.brandService.getBrand();
  }

  get nameValue(): string {
    return this.nameControl.value;
  }

  constructor(
    private brandService: BrandService,
    private fb: UntypedFormBuilder,
  ) {
    this.createNameControl();
  }

  ngOnInit() {
    this.init();
  }

  public resetControl(value: string|number = ''): void {
    this.nameControl.reset(value);
  }

  public init(): void {
    this.datetime = moment().format('MMDDYYYYHHmmss');
    this.resetControl('');
  }

  private createNameControl(): void {
    this.nameControl = new UntypedFormControl('', Validators.compose([
      maxLengthSpec(this.maxCharactersCount),
      Validators.pattern('^[^*|:<>?/\]+$'),
    ]));
  }
}
